import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, Validator } from '@angular/forms';
import { DateUtils } from '../Utils/date.utils';

/**
 * Kontrola, že datum předpokládaného sběru je minimálně 15 dní po aktuálním datu.
**/
@Injectable({
  providedIn: 'root'
})
export class DatumSberuOdValidator implements Validator
{
  private dniPredem: number = 15;

  constructor(
    private dateUtils: DateUtils
  ) { }

  validate(control: AbstractControl): ValidationErrors | null {
    if (control.value == void 0 || control.value == '') {
      return null;
    }

    let sberOd = this.dateUtils.getDateWithoutTime(new Date(Date.parse(control.value)));
    let limitDate = this.dateUtils.getDateWithoutTime(this.dateUtils.addDays(new Date(), this.dniPredem));
    if (sberOd >= limitDate) {
      return null;
    }
    else {
      return { 'sberOd': 'Oznámení o sběru RM musí být podáno nejméně 15 dnů před datem zahájení sběru.' };
    }
  }
}
